/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import React from 'react';
import ProductDropDown from 'src/business-components/ProductDropDown';
import FormikInput from 'src/components/formik/FormikInput';

function LoanForm({ values }) {
    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Loan Details</h5>
                <div className="form-row">
                    <div className="form-group col-md-3">
                        <label>Loan for Product</label>
                        <ProductDropDown
                            name="productId"
                            value={values.productId}
                        />
                    </div>

                    <div className="form-group col-md-3">
                        <label>Min Tenure / Duration</label>
                        <FormikInput
                            name="meta.minTenure"
                            type="number"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Max Tenure / Duration</label>
                        <FormikInput
                            name="meta.maxTenure"
                            type="number"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Min Amount</label>
                        <FormikInput
                            name="meta.minAmount"
                            type="number"
                            className="form-control"
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>Max Amount</label>
                        <FormikInput
                            name="meta.maxAmount"
                            type="number"
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

LoanForm.propTypes = {
    values: PropTypes.shape({
        productId: PropTypes.string,
    }).isRequired,
};

export default LoanForm;
